import { GitBranch1, Grid1 } from "@hortis/ui/icons";
import { Link } from "@tanstack/react-router";
import { NavItem } from "../nav-list/nav-item";

export const OrganizationNavList = ({
  onNavigate,
}: { onNavigate: () => void }) => (
  <div className="space-y-1">
    <div className="px-3 py-1 text-xs font-medium text-grey-500">
      Organization
    </div>
    <nav className="flex flex-col gap-px">
      <NavItem asChild>
        <Link to="/sites" onClick={onNavigate} activeOptions={{ exact: true }}>
          <Grid1 />
          Sites
        </Link>
      </NavItem>
      <NavItem asChild>
        <Link to="/taxa" onClick={onNavigate} activeOptions={{ exact: true }}>
          <GitBranch1 />
          Taxa
        </Link>
      </NavItem>
    </nav>
  </div>
);
